/**
 * 对话框
 */
const {ccclass, property} = cc._decorator;
@ccclass
export default class DialogueNode extends cc.Component {

    private mContent : string;

    onLoad () {

    }

    start () {
        this.mContent = this.node.getChildByName("lbDialogueContent").getComponent(cc.Label).string;
        this.node.getChildByName("lbDialogueContent").getComponent(cc.Label).string = "";
        this.node.opacity = 0;
        cc.tween( this.node)
            .to(0.8,{opacity:255})
            .call(()=>{
                this.showContent();
            }).start();
    }

    /**
     * 展示内容
     */
    showContent(){
        if ( this.node.getChildByName("lbDialogueContent").getComponent(cc.Label).string.length == this.mContent.length ) {
            return;
        }
        this.node.getChildByName("lbDialogueContent").getComponent(cc.Label).string = this.mContent.substr( 0 , this.node.getChildByName("lbDialogueContent").getComponent(cc.Label).string.length + 1 );
        this.scheduleOnce(()=>{
            this.showContent();
        },0.15);
    }

    // update (dt) {}
}
